import { runningClientSide } from '@benzinga/utils';

const optimizelyInitScriptId = 'optimizely-init-script';

export const injectOptimizelyScript = () => {
  if (!runningClientSide()) return;
  const scriptElement = document.createElement('script');
  scriptElement.src = 'https://cdn.optimizely.com/js/6089398316433408.js';
  scriptElement.setAttribute('id', optimizelyInitScriptId);
  scriptElement.onerror = (event: Event | string) => {
    if (typeof event === 'object' && event?.type === 'error') {
      console.error('Failed to inject Optimizely script');
    }
  };

  document.head.appendChild(scriptElement);
};

export const removeOptimizelyScript = () => {
  if (!runningClientSide()) return;
  const script = document.querySelector(`#${optimizelyInitScriptId}`);
  if (script) {
    script.remove();
  }
};
